import React from 'react';
import { LOCK_SHIFT_PERMISSION } from 'pages/LockShiftOpen/utils/permissions';

const LockShiftOpen = React.lazy(() => import('pages/LockShiftOpen/pages/DefaultPage'));
const LockShiftAdd = React.lazy(() => import('pages/LockShiftOpen/pages/AddPage'));
const LockShiftDetail = React.lazy(() => import('pages/LockShiftOpen/pages/DetailPage'));
const LockShiftEdit = React.lazy(() => import('pages/LockShiftOpen/pages/EditPage'));

const lockshiftOpen = [
  {
    path: '/lockshift-open',
    exact: true,
    name: 'Danh sách nhận ca',
    function: LOCK_SHIFT_PERMISSION.VIEW,
    component: LockShiftOpen,
  },
  {
    path: '/lockshift-open/add',
    exact: true,
    name: 'Thêm mới nhận ca',
    function: LOCK_SHIFT_PERMISSION.HANDOVER_CONFIRM,
    component: LockShiftAdd,
  },
  {
    path: '/lockshift-open/edit/:id',
    exact: true,
    name: 'Chỉnh sửa nhận ca',
    function: LOCK_SHIFT_PERMISSION.EDIT,
    component: LockShiftEdit,
  },
  {
    path: '/lockshift-open/detail/:id',
    exact: true,
    name: 'Chi tiết nhận ca',
    function: LOCK_SHIFT_PERMISSION.VIEW,
    component: LockShiftDetail,
  },
];

export default lockshiftOpen;
